export { DialogRemoveLapAccess } from './dialog-remove-lap-access';
